module.exports = "/static/assets/176ab990f78c97e4592a10ddf1cf04dd.png";